/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react";
import { collection, getDocs, doc, deleteDoc, updateDoc, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase"; 

import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";

import { Grid, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Button, Box, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, Divider } from "@mui/material";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openView, setOpenView] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  
  const [pendingStatuses, setPendingStatuses] = useState({});

  const userRole = localStorage.getItem("userRole");

  // Helper function to format Firebase Timestamp into readable Date & Time
  const formatDateTime = (timestamp) => {
    if (!timestamp) return "غير متوفر";
    // Convert Firebase timestamp to standard JS Date object
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    
    // Format to look like: "12 Apr 2026, 03:45 PM" in Arabic
    return date.toLocaleString('ar-EG', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      // Fetch orders sorted by newest first
      const q = query(collection(db, "orders"), orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);
      
      setOrders(querySnapshot.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (error) { console.error(error); }
    setLoading(false);
  };

  useEffect(() => { fetchOrders(); }, []);

  const handleDropdownChange = (orderId, value) => {
    setPendingStatuses(prev => ({ ...prev, [orderId]: value }));
  };

const handleStatusUpdate = async (id) => {
    const newStatus = pendingStatuses[id];
    if (!newStatus) return; 

    try {
      await updateDoc(doc(db, "orders", id), { status: newStatus });
      
      // 🟢 NEW: Clear the temporary status so the button visually resets
      setPendingStatuses(prev => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });

      alert("تم تحديث حالة الطلب بنجاح!");
      fetchOrders(); 
    } catch (error) {
      console.error("Error updating status:", error);
      alert("حدث خطأ أثناء تحديث الحالة. تأكد من قواعد Firebase!");
    }
  };

  const handleOpenView = (order) => {
    setSelectedOrder(order);
    setOpenView(true);
  };

  const handleCloseView = () => {
    setOpenView(false);
    setSelectedOrder(null);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ pt: 3, pb: 3, direction: "rtl" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card sx={{ p: 3, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)" }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 3, color: "#344767" }}>
                طلبات العملاء من الموقع
              </Typography>

              <TableContainer sx={{ overflowX: "auto", border: "1px solid #f0f2f5", borderRadius: "8px" }}>
                <Table sx={{ minWidth: 1050 }}> 
                  <TableHead sx={{ display: "table-header-group", backgroundColor: "#f8f9fa" }}>
                    <TableRow>
                      <TableCell align="center" sx={{ fontWeight: "bold", color: "#7b809a" }}>رقم الطلب</TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold", color: "#7b809a" }}>التاريخ والوقت</TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold", color: "#7b809a" }}>اسم العميل</TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold", color: "#7b809a" }}>رقم الهاتف</TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold", color: "#7b809a" }}>الحالة</TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold", color: "#7b809a" }}>الإجراءات</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ color: "#7b809a", padding: "20px" }}>جاري تحميل الطلبات...</TableCell>
                      </TableRow>
                    ) : orders.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ color: "#7b809a", padding: "20px" }}>لا توجد طلبات حالياً</TableCell>
                      </TableRow>
                    ) : (
                      orders.map((order) => (
                        <TableRow key={order.id} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          
                          <TableCell align="center">
                            <Typography variant="button" fontWeight="bold" color="#1A73E8">
                              #{order.orderNumber ? order.orderNumber : "قديم"}
                            </Typography>
                          </TableCell>

                          {/* Display Formatted Date and Time */}
                          <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                            <Typography variant="caption" fontWeight="bold" color="textSecondary">
                              {formatDateTime(order.createdAt)}
                            </Typography>
                          </TableCell>

                          <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                            <Typography variant="button" fontWeight="bold" color="#344767">
                              {order.name}
                            </Typography>
                          </TableCell>

                          <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                            <Typography variant="caption" color="textPrimary" fontWeight="medium">
                              {order.phone}
                            </Typography>
                          </TableCell>
                          
           <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                              <Select
                                value={pendingStatuses[order.id] || order.status || "طلب جديد"}
                                onChange={(e) => handleDropdownChange(order.id, e.target.value)}
                                size="small"
                                // 🟢 NEW: Completely disable the dropdown if the order is already delivered
                                disabled={order.status === "تم التسليم"}
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "0.8rem",
                                  borderRadius: "8px",
                                  minWidth: "120px",
                                  backgroundColor: 
                                    (pendingStatuses[order.id] || order.status) === "تم التسليم" ? "#e8f5e9" : 
                                    (pendingStatuses[order.id] || order.status) === "قيد التنفيذ" ? "#e3f2fd" : "#fff3e0",
                                  color: 
                                    (pendingStatuses[order.id] || order.status) === "تم التسليم" ? "#2e7d32" : 
                                    (pendingStatuses[order.id] || order.status) === "قيد التنفيذ" ? "#1565c0" : "#ed6c02",
                                  // Add a slight opacity if disabled so it looks visually "locked"
                                  opacity: order.status === "تم التسليم" ? 0.7 : 1 
                                }}
                              >
                                <MenuItem value="طلب جديد" sx={{ fontWeight: "bold", color: "#ed6c02" }}>طلب جديد</MenuItem>
                                <MenuItem value="قيد التنفيذ" sx={{ fontWeight: "bold", color: "#1565c0" }}>قيد التنفيذ</MenuItem>
                                <MenuItem value="تم التسليم" sx={{ fontWeight: "bold", color: "#2e7d32" }}>تم التسليم</MenuItem>
                              </Select>
                              
                              <Button 
                                variant="contained" 
                                size="small"
                                color="success"
                                onClick={() => handleStatusUpdate(order.id)}
                                // 🟢 NEW: Disable the button if it's already delivered
                                disabled={order.status === "تم التسليم" || !pendingStatuses[order.id] || pendingStatuses[order.id] === order.status}
                                sx={{ fontWeight: "bold" }}
                              >
                                تحديث
                              </Button>
                            </Box>
                          </TableCell>
                          
                          <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                            <Button 
                              variant="outlined" 
                              size="small" 
                              onClick={() => handleOpenView(order)} 
                              sx={{ 
                                marginLeft: "10px", 
                                borderColor: "#344767", 
                                color: "#344767", 
                                fontWeight: "bold"
                              }}
                            >
                              عرض التفاصيل
                            </Button>
                            
                            {userRole === "admin" && (
                              <Button 
                                variant="contained" 
                                size="small" 
                                onClick={() => { if(window.confirm("هل أنت متأكد من حذف هذا الطلب نهائياً؟")) deleteDoc(doc(db, "orders", order.id)).then(fetchOrders) }} 
                                sx={{ 
                                  backgroundColor: "#F44336 !important", 
                                  color: "#fff !important", 
                                  fontWeight: "bold"
                                }}
                              >
                                حذف
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Full Order Details Modal */}
      <Dialog open={openView} onClose={handleCloseView} maxWidth="sm" fullWidth dir="rtl">
        {selectedOrder && (
          <>
            <DialogTitle sx={{ textAlign: "right", fontWeight: "bold", color: "#344767", borderBottom: "1px solid #eee", pb: 2 }}>
              تفاصيل الطلب: #{selectedOrder.orderNumber ? selectedOrder.orderNumber : "قديم"}
            </DialogTitle>
            
            <DialogContent sx={{ mt: 2 }}>
              <Box mb={3}>
                <Typography variant="subtitle1" fontWeight="bold" color="#1A73E8" mb={1}>معلومات العميل</Typography>
                <Typography variant="body2" mb={0.5}><strong>الاسم:</strong> {selectedOrder.name}</Typography>
                <Typography variant="body2" mb={0.5}><strong>رقم الهاتف:</strong> {selectedOrder.phone}</Typography>
                <Typography variant="body2" mb={0.5}><strong>البريد:</strong> {selectedOrder.gmail || "لا يوجد"}</Typography>
                <Typography variant="body2" mb={0.5}><strong>العنوان:</strong> {selectedOrder.address}</Typography>
                <Typography variant="body2" color="textSecondary"><strong>وقت الطلب:</strong> {formatDateTime(selectedOrder.createdAt)}</Typography>
              </Box>

              <Divider sx={{ mb: 3 }} />

              <Box mb={3}>
                <Typography variant="subtitle1" fontWeight="bold" color="#1A73E8" mb={1}>المنتجات المطلوبة</Typography>
                <Box sx={{ backgroundColor: "#f8f9fa", p: 2, borderRadius: "8px" }}>
                  {selectedOrder.products?.map((p, i) => (
                    <Typography key={i} variant="body2" sx={{ display: "flex", justifyContent: "space-between", mb: 1, borderBottom: i !== selectedOrder.products.length - 1 ? "1px solid #ddd" : "none", pb: 1 }}>
                      
                      {/* 🟢 FIXED: Now it displays the Code (if it exists) next to the Name */}
                      <span>
                        {p.productCode && (
                          <span style={{ color: "#ed6c02", fontWeight: "bold", marginLeft: "8px" }}>
                            [{p.productCode}]
                          </span>
                        )}
                        {p.productName}
                      </span>

                      <span style={{ fontWeight: "bold" }}>الكمية: {p.quantity}</span>
                    </Typography>
                  ))}
                </Box>
              </Box>

              
              <Divider sx={{ mb: 3 }} />

              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" fontWeight="bold" color="#344767">الإجمالي: {selectedOrder.totalPrice} ج.م</Typography>
                <Typography variant="button" sx={{ fontWeight: "bold", color: selectedOrder.status === "تم التسليم" ? "#2e7d32" : selectedOrder.status === "قيد التنفيذ" ? "#1565c0" : "#ed6c02" }}>
                  حالة الطلب: {selectedOrder.status}
                </Typography>
              </Box>

            </DialogContent>

            <DialogActions sx={{ p: 3, pt: 0 }}>
              <Button onClick={handleCloseView} variant="contained" sx={{ backgroundColor: "#344767 !important", color: "white !important", width: "100%" }}>
                إغلاق
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

    </DashboardLayout>
  );
}